import defaultLocales from 'globals/locales/default';

export const longerHeadLabels = [
  defaultLocales.teammate,
  defaultLocales.role,
  defaultLocales.lastActivity,
  defaultLocales.createdAt,
  defaultLocales.status,
  '',
];

export const shorterHeadLabels = [
  defaultLocales.teammate,
  defaultLocales.activity,
  defaultLocales.status,
  '',
];

export const dummyPagination = {
  itemsPerPage: 10,
  currentPage: 1,
  numberOfPages: 100,
};
